export interface RolesInvUnidadDTO {
    idrolpersona: number
    idrol: number
    nombreRol: string
    idunidad: number
    nombreUnidad: string
    estado: string
}

export function VoidRolesInvUnidadDTO(): RolesInvUnidadDTO {
    return {
        idrolpersona: 0,
        idrol: 160,
        nombreRol: '',
        idunidad: 15004,
        nombreUnidad: '',
        estado: 'A'
    }
}